export const getFormattedData = ({ isPrepaid, title, iconId, data }) => {
    const pageTitle = isPrepaid
        ? `${title} Icon ${iconId} - Prepaid Checkout | Noun Project`
        : `${title} Icon ${iconId} - Checkout | Noun Project`;

    const formSectionHeading = isPrepaid ? "Use Prepaid Balance" : null;

    const hasData = data && data.iconDetail;

    return {
        pageTitle,
        formSectionHeading,
        hasData
    };
};
